import { COLLECTION_NAME } from ".";
import { updateDocument } from "db/mutations";

export const updateStory = async (storyId, storyData) => {
  try {
    await updateDocument(COLLECTION_NAME, storyId, storyData);
    return { success: true };
  } catch (error) {
    console.error("Error updating story:", error);
    return { success: false, error: error.message };
  }
};
